import React, { Component } from 'react';

import IceContainer from '@icedesign/container';

import { withRouter } from 'react-router-dom';

import PropTypes from 'prop-types';

import { getAuthority } from '@/auth/authority';
import Auths from '@/auth/Auths';
import { formatMessage } from '@/i18n';

import './Exception.scss';

@withRouter
export default class Exception extends Component {
  static displayName = 'Exception';

  static propTypes = {
    type: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  };

  static defaultProps = {
    type: 404,
  };

  render() {
    let view = null;
    switch (this.props.type) {
      case '204':
      case 204:
        view = this.render204();
        break;
      case '403':
      case 403:
        view = this.render403();
        break;
      case '404':
      case 404:
        view = this.render404();
        break;
      case '500':
      case 500:
        view = this.render500();
        break;
      case '0':
      case 0:
        view = this.renderBlocked();
        break;
      default:
        view = this.render404();
        break;
    }
    return view;
  }

  render204 = () => {
    return (
      <IceContainer>
        <div
          style={styles.exceptionContent}
          className="exception-content-ie-flex exception-content"
        >
          <img
            src={require('./images/204.png')}
            style={styles.image}
            className="imgException"
            alt="204-no-content"
          />
          <div style={styles.prompt}>
            <h3 style={styles.title} className="title">
              {formatMessage('exception.204.title')}
            </h3>
            <p style={styles.description} className="description">
              {formatMessage('exception.204.desc')}
              {formatMessage('exception.please')}
              <a style={styles.link} onClick={this.goHome}>
                {formatMessage('exception.home')}
              </a>
              {formatMessage('exception.or')}
              <a style={styles.link} onClick={this.goBack}>
                {formatMessage('exception.back')}
              </a>
            </p>
          </div>
        </div>
      </IceContainer>
    );
  };

  render403 = () => {
    return (
      <IceContainer>
        <div
          style={styles.exceptionContent}
          className="exception-content-ie-flex exception-content"
        >
          <img
            src={require('./images/403.png')}
            style={styles.imgException}
            className="imgException"
            alt="403-forbid"
          />
          <div style={styles.prompt}>
            <h3 style={styles.title} className="title">
              {formatMessage('exception.403.title')}
            </h3>
            <p style={styles.description} className="description">
              {formatMessage('exception.403.desc')}
              {formatMessage('exception.please')}
              <a style={styles.link} onClick={this.goHome}>
                {formatMessage('exception.home')}
              </a>
              {formatMessage('exception.or')}
              <a style={styles.link} onClick={this.goBack}>
                {formatMessage('exception.back')}
              </a>
            </p>
          </div>
        </div>
      </IceContainer>
    );
  };

  render404 = () => {
    return (
      <IceContainer>
        <div
          style={styles.exceptionContent}
          className="exception-content-ie-flex exception-content"
        >
          <img
            src={require('./images/404.png')}
            style={styles.image}
            className="imgException"
            alt="404-not-found"
          />
          <div className="prompt">
            <h3 style={styles.title} className="title">
              {formatMessage('exception.404.title')}
            </h3>
            <p style={styles.description} className="description">
              {formatMessage('exception.404.desc')}
              {formatMessage('exception.please')}
              <a style={styles.link} onClick={this.goHome}>
                {formatMessage('exception.home')}
              </a>
              {formatMessage('exception.or')}
              <a style={styles.link} onClick={this.goBack}>
                {formatMessage('exception.back')}
              </a>
            </p>
          </div>
        </div>
      </IceContainer>
    );
  };

  render500 = () => {
    return (
      <IceContainer>
        <div
          style={styles.exceptionContent}
          className="exception-content-ie-flex exception-content"
        >
          <img
            src={require('./images/500.png')}
            style={styles.imgException}
            className="imgException"
            alt="500-internal-error"
          />
          <div>
            <h3 style={styles.title} className="title">
              {formatMessage('exception.500.title')}
            </h3>
            <p style={styles.description} className="description">
              {formatMessage('exception.500.desc')}
              {formatMessage('exception.please')}
              <a style={styles.link} onClick={this.goHome}>
                {formatMessage('exception.home')}
              </a>
              {formatMessage('exception.or')}
              <a style={styles.link} onClick={this.goBack}>
                {formatMessage('exception.back')}
              </a>
            </p>
          </div>
        </div>
      </IceContainer>
    );
  };

  renderBlocked = () => {
    return (
      <IceContainer>
        <div
          style={styles.exceptionContent}
          className="exception-content-ie-flex exception-content"
        >
          <img
            src={require('./images/0.png')}
            style={styles.imgException}
            className="imgException"
            alt="0-disconnected"
          />
          <div>
            <h3 style={styles.title} className="title">
              {formatMessage('exception.blocked.title')}
            </h3>
            <p style={styles.description} className="description">
              {/* 连接服务器失败，请稍后重试或返回<Link to="/">首页</Link> */}
              {formatMessage('exception.blocked.desc')}
              {formatMessage('exception.please')}
              <a style={styles.link} onClick={this.goHome}>
                {formatMessage('exception.home')}
              </a>
              {formatMessage('exception.or')}
              <a style={styles.link} onClick={this.goBack}>
                {formatMessage('exception.back')}
              </a>
            </p>
          </div>
        </div>
      </IceContainer>
    );
  };

  goBack = () => {
    this.props.history.goBack();
  };

  goHome = () => {
    this.props.history.replace(getAuthority()?.includes(Auths.ADMINISTRATOR) ? '/company' : '/');
  };
}

const styles = {
  exceptionContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    color: '#333',
  },
  description: {
    color: '#666',
  },
  link: {
    color: '#347af6',
    cursor: 'pointer',
  },
};
